import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProcessoRoutingModule } from './processo-routing.module';
import { ListaComponent } from './pages/lista/lista.component';
import { NovoComponent } from './pages/novo/novo.component';
import { DetalhesComponent } from './pages/detalhes/detalhes.component';
import { NovaPastaComponent } from '../componentes/nova-pasta/nova-pasta.component';
import { VisualizarProcessoComponent } from './pages/visualizar-processo/visualizar-processo.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxPaginationModule} from "ngx-pagination";
import {TarefaModule} from "../tarefa/tarefa.module";
import {AngularEditorModule} from "@kolkov/angular-editor";
import {ClienteModule} from "../../cadastro/cliente/cliente.module";
import {AtendimentoModule} from "../../cadastro/atendimento/atendimento.module";
import {CadastroModule} from "../../cadastro/cadastro.module";
import {DocumentoProcessoModule} from "../documento-processo/documento-processo.module";
import {AudienciaModule} from "../audiencia/audiencia.module";


@NgModule({
  declarations: [
    ListaComponent,
    NovoComponent,
    DetalhesComponent,
    NovaPastaComponent,
    VisualizarProcessoComponent
  ],
    imports: [
        CommonModule,
        ProcessoRoutingModule,
        ComponentesModule,
        FormsModule,
        NgSelectModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        TarefaModule,
        AngularEditorModule,
        ClienteModule,
        AtendimentoModule,
        CadastroModule,
        DocumentoProcessoModule,
        AudienciaModule
    ]
})
export class ProcessoModule { }
